import { render, staticRenderFns } from "./LocalAvatarMigrateDialog.vue?vue&type=template&id=2bafdb4a&scoped=true"
import script from "./LocalAvatarMigrateDialog.vue?vue&type=script&lang=js"
export * from "./LocalAvatarMigrateDialog.vue?vue&type=script&lang=js"
import style0 from "./LocalAvatarMigrateDialog.vue?vue&type=style&index=0&id=2bafdb4a&prod&scoped=true&lang=css"
import style1 from "./LocalAvatarMigrateDialog.vue?vue&type=style&index=1&id=2bafdb4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafdb4a",
  null
  
)

export default component.exports